module.exports = __webpack_public_path__ + "stockLibrary/landing-modal-img-4-c3111bba5cd9afc7baa0d7693f9e05fc.png";